import React, {useCallback, useEffect} from 'react'
import {useRouter} from 'next/router'
import dynamic from 'next/dynamic'

import {setCookie} from '@util/cookie'
import {setUserProperty} from '@util/amplitude'

import useQueryGetExchanges from '@hook/query/core/exchange/useQueryGetExchanges'

import ChartInitializer from '@component/core/ChartInitializer'
import NatsInitializer from '@component/core/NatsInitializer'
import DatadogInitializer from '@component/core/DatadogInitializer'
import WindowStateInitializer from '@component/core/WindowStateInitializer'
import DarkModeInitializer from '@component/core/DarkModeInitializer'
import SnackbarLoader from '@component/snackbar/SnackbarLoader'

const BottomSheetArea = dynamic(() => import('@component/core/BottomSheetArea'), {ssr: false})

const Loader = () => {
    const router = useRouter()

    const {refetch: refetchExchanges} = useQueryGetExchanges()

    const setLanguageCookie = useCallback((language: string) => {
        setUserProperty('locale', language)
        setCookie('language', language)
    }, [])

    useEffect(() => {
        setLanguageCookie(router.locale)

        refetchExchanges()
    }, [router.locale])

    return (
        <>
            <ChartInitializer />
            <NatsInitializer />
            <DatadogInitializer />
            <WindowStateInitializer />
            <DarkModeInitializer />
            <SnackbarLoader />
            <BottomSheetArea />
        </>
    )
}

export default Loader
